module.exports = __webpack_public_path__ + "img/qa.97b9b44e.svg";